
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.5 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1697f6","d":"M43.75 0H23.31l20.44 48.32"}}),_c('path',{attrs:{"fill":"#7bc6ff","d":"M43.75 62.5V100L0 14.58h22.92L43.75 62.5z"}}),_c('path',{attrs:{"fill":"#1867c0","d":"M43.75 0h20.44L43.75 48.32"}}),_c('path',{attrs:{"fill":"#aeddff","d":"M64.58 14.58H87.5L43.75 100V62.5l20.83-47.92z"}})])
          )
        }
      }
    